import { useState, useEffect, useMemo, useRef } from 'react';
import { InputGroup, Input } from 'rsuite';
import debounce from 'lodash.debounce';
import { icons } from '@shared/static/icons';

export default function SearchTable({ handleSearch, value, placeholder }) {
  const inputRef = useRef(null);

  const [localValue, setLocalValue] = useState(value || '');

  const debouncedHandleSearch = useMemo(
    () =>
      debounce((val) => {
        handleSearch(val || '');
      }, 500),
    [handleSearch],
  );

  useEffect(() => {
    const wasFocused = document.activeElement === inputRef.current;
    setLocalValue(value || '');
    if (!wasFocused || !inputRef.current) return;

    const timer = setTimeout(() => {
      inputRef.current?.focus();
    }, 0);

    return () => clearTimeout(timer);
  }, [value]);

  useEffect(() => {
    return () => debouncedHandleSearch.cancel();
  }, [debouncedHandleSearch]);

  const onTextChange = (val) => {
    setLocalValue(val);
    debouncedHandleSearch(val);
  };

  const onClean = () => {
    inputRef.current?.focus();
    setLocalValue('');
    handleSearch('');
  };

  return (
    <div className="search-group">
      <InputGroup className={localValue ? 'has-value' : ''}>
        <Input
          ref={inputRef}
          value={localValue}
          placeholder={placeholder}
          onChange={onTextChange}
        />
        {localValue ? (
          <InputGroup.Button tabIndex={-1} onClick={onClean}>
            {icons.close}
          </InputGroup.Button>
        ) : (
          <InputGroup.Button>{icons.search}</InputGroup.Button>
        )}
      </InputGroup>
    </div>
  );
}
